import { render, staticRenderFns } from "./BnModal.vue?vue&type=template&id=684e3fc9&"
import script from "./BnModal.vue?vue&type=script&lang=js&"
export * from "./BnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports